var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserInactiveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4769_4519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8076 19.0712C22.5578 17.717 21.0412 16.6364 19.3532 15.8973C17.6652 15.1582 15.8425 14.7766 13.9998 14.7766C12.1571 14.7766 10.3344 15.1582 8.64638 15.8973C6.95841 16.6364 5.44178 17.717 4.19201 19.0712C3.99905 19.2845 3.89112 19.5613 3.88867 19.8489V24.5156C3.89276 24.8223 4.01748 25.1151 4.23583 25.3305C4.45418 25.546 4.7486 25.6667 5.05534 25.6667H22.9442C23.2536 25.6667 23.5504 25.5438 23.7692 25.325C23.988 25.1062 24.1109 24.8095 24.1109 24.5V19.8334C24.1047 19.5511 23.997 19.2805 23.8076 19.0712Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 13.2223C17.007 13.2223 19.4446 10.7847 19.4446 7.77782C19.4446 4.77093 17.007 2.33337 14.0001 2.33337C10.9932 2.33337 8.55566 4.77093 8.55566 7.77782C8.55566 10.7847 10.9932 13.2223 14.0001 13.2223Z",
    fill: "#070707"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4769_4519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInactiveIcon);
export default __webpack_public_path__ + "static/media/userInactiveIcon.7a62d55e296cbbfbc967337f01b0a0b4.svg";
export { ForwardRef as ReactComponent };